module.exports = __webpack_public_path__ + "img/down.e1a95a33.svg";